import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Accordion, Button, Chip, Text } from '@frontend/design-system';
import { HydratedCallRecord } from '../types';
import { CallQualityFeedback, IssuesDetectedSection, StablePerformanceSection } from './call-quality-components';

interface CallQualityAccordionItemProps {
  call: HydratedCallRecord;
  hasIssues: boolean;
  title?: string;
  onClick?: () => void;
}

export const CallQualityAccordionItem: FC<CallQualityAccordionItemProps> = ({ call, hasIssues, title, onClick }) => {
  const { t } = useTranslation('calls');

  return (
    <>
      <Accordion.Header>
        <div css={{ display: 'grid' }}>
          <Text weight='bold' css={{ fontSize: theme.fontSize(18) }}>
            {title || t('Network Performance')}
          </Text>
          {hasIssues ? (
            <Chip variant='warn' css={{ width: 'max-content', maxWidth: 'max-content' }}>
              {t('Issues Detected')}
            </Chip>
          ) : (
            <Chip variant='success' css={{ width: 'max-content' }}>
              {t('Stable')}
            </Chip>
          )}
        </div>
      </Accordion.Header>

      <Accordion.Body>
        <div css={{ display: 'grid', gap: theme.spacing(2) }}>
          {hasIssues ? (
            <div css={{ display: 'grid', gap: theme.spacing(2) }}>
              <IssuesDetectedSection variant='preview' />
              <Button variant='tertiary' onClick={onClick} css={{ justifySelf: 'start' }}>
                {t('View Details')}
              </Button>
              <CallQualityFeedback
                channelId={call.channelId ?? ''}
                locationId={call.locationId ?? ''}
                startTime={call.startedAt ?? ''}
              />
            </div>
          ) : (
            <StablePerformanceSection item={call} />
          )}
        </div>
      </Accordion.Body>
    </>
  );
};
